// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-gallery-icon {
  color: #fff;
  transition: all 0.3s ease-out;
  appearance: none;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  outline: none;
  position: absolute;
  z-index: 4;
  filter: drop-shadow(0 2px 2px #1a1a1a);
}
@media (hover: hover) and (pointer: fine) {
  .image-gallery-icon:hover {
    color: #337ab7;
  }
  .image-gallery-icon:hover .image-gallery-svg {
    transform: scale(1.1);
  }
}
.image-gallery-icon:focus {
  outline: 2px solid #337ab7;
}

.image-gallery-using-mouse .image-gallery-icon:focus {
  outline: none;
}

.image-gallery-fullscreen-button,
.image-gallery-play-button {
  bottom: 0;
  padding: 20px;
}
.image-gallery-fullscreen-button .image-gallery-svg,
.image-gallery-play-button .image-gallery-svg {
  height: 28px;
  width: 28px;
}
@media (max-width: 768px) {
  .image-gallery-fullscreen-button,
  .image-gallery-play-button {
    padding: 15px;
  }
  .image-gallery-fullscreen-button .image-gallery-svg,
  .image-gallery-play-button .image-gallery-svg {
    height: 24px;
    width: 24px;
  }
}
@media (max-width: 480px) {
  .image-gallery-fullscreen-button,
  .image-gallery-play-button {
    padding: 10px;
  }
  .image-gallery-fullscreen-button .image-gallery-svg,
  .image-gallery-play-button .image-gallery-svg {
    height: 16px;
    width: 16px;
  }
}

.image-gallery-fullscreen-button {
  right: 0;
}

.image-gallery-play-button {
  left: 0;
}

.image-gallery-left-nav,
.image-gallery-right-nav {
  padding: 50px 10px;
  top: 50%;
  transform: translateY(-50%);
}
.image-gallery-left-nav .image-gallery-svg,
.image-gallery-right-nav .image-gallery-svg {
  height: 120px;
  width: 60px;
}
@media (max-width: 768px) {
  .image-gallery-left-nav .image-gallery-svg,
  .image-gallery-right-nav .image-gallery-svg {
    height: 72px;
    width: 36px;
  }
}
@media (max-width: 480px) {
  .image-gallery-left-nav .image-gallery-svg,
  .image-gallery-right-nav .image-gallery-svg {
    height: 48px;
    width: 24px;
  }
}
.image-gallery-left-nav[disabled],
.image-gallery-right-nav[disabled] {
  cursor: disabled;
  opacity: 0.6;
  pointer-events: none;
}

.image-gallery-left-nav {
  left: 0;
}

.image-gallery-right-nav {
  right: 0;
}

.image-gallery {
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  position: relative;
}
.image-gallery.fullscreen-modal {
  background: #000;
  bottom: 0;
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 5;
}
.image-gallery.fullscreen-modal .image-gallery-content {
  top: 50%;
  transform: translateY(-50%);
}

.image-gallery-content {
  position: relative;
  line-height: 0;
  top: 0;
}
.image-gallery-content.fullscreen {
  background: #000;
}
.image-gallery-content .image-gallery-slide .image-gallery-image {
  max-height: calc(100vh - 80px);
}
.image-gallery-content.image-gallery-thumbnails-left .image-gallery-slide .image-gallery-image, .image-gallery-content.image-gallery-thumbnails-right .image-gallery-slide .image-gallery-image {
  max-height: 100vh;
}

.image-gallery-slide-wrapper {
  position: relative;
}
.image-gallery-slide-wrapper.image-gallery-thumbnails-left, .image-gallery-slide-wrapper.image-gallery-thumbnails-right {
  display: inline-block;
  width: calc(100% - 110px);
}
@media (max-width: 768px) {
  .image-gallery-slide-wrapper.image-gallery-thumbnails-left, .image-gallery-slide-wrapper.image-gallery-thumbnails-right {
    width: calc(100% - 87px);
  }
}
.image-gallery-slide-wrapper.image-gallery-rtl {
  direction: rtl;
}

.image-gallery-slides {
  line-height: 0;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
  text-align: center;
}

.image-gallery-slide {
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.image-gallery-slide.image-gallery-center {
  position: relative;
}
.image-gallery-slide .image-gallery-image {
  width: 100%;
  object-fit: contain;
}
.image-gallery-slide .image-gallery-description {
  background: rgba(0, 0, 0, 0.4);
  bottom: 70px;
  color: #fff;
  left: 0;
  line-height: 1;
  padding: 10px 20px;
  position: absolute;
  white-space: normal;
}
@media (max-width: 768px) {
  .image-gallery-slide .image-gallery-description {
    bottom: 45px;
    font-size: 0.8em;
    padding: 8px 15px;
  }
}

.image-gallery-bullets {
  bottom: 20px;
  left: 0;
  margin: 0 auto;
  position: absolute;
  right: 0;
  width: 80%;
  z-index: 4;
}
.image-gallery-bullets .image-gallery-bullets-container {
  margin: 0;
  padding: 0;
  text-align: center;
}
.image-gallery-bullets .image-gallery-bullet {
  appearance: none;
  background-color: transparent;
  border: 1px solid #fff;
  border-radius: 50%;
  box-shadow: 0 2px 2px #1a1a1a;
  cursor: pointer;
  display: inline-block;
  margin: 0 5px;
  outline: none;
  padding: 5px;
  transition: all 0.2s ease-out;
}
@media (max-width: 768px) {
  .image-gallery-bullets .image-gallery-bullet {
    margin: 0 3px;
    padding: 3px;
  }
}
@media (max-width: 480px) {
  .image-gallery-bullets .image-gallery-bullet {
    padding: 2.7px;
  }
}
.image-gallery-bullets .image-gallery-bullet:focus {
  transform: scale(1.2);
  background: #337ab7;
  border: 1px solid #337ab7;
}
.image-gallery-bullets .image-gallery-bullet.active {
  transform: scale(1.2);
  border: 1px solid #fff;
  background: #fff;
}
@media (hover: hover) and (pointer: fine) {
  .image-gallery-bullets .image-gallery-bullet:hover {
    background: #337ab7;
    border: 1px solid #337ab7;
  }
  .image-gallery-bullets .image-gallery-bullet.active:hover {
    background: #337ab7;
  }
}

.image-gallery-thumbnails-wrapper {
  position: relative;
}
.image-gallery-thumbnails-wrapper.thumbnails-swipe-horizontal {
  touch-action: pan-y;
}
.image-gallery-thumbnails-wrapper.thumbnails-swipe-vertical {
  touch-action: pan-x;
}
.image-gallery-thumbnails-wrapper.thumbnails-wrapper-rtl {
  direction: rtl;
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
  display: inline-block;
  vertical-align: top;
  width: 100px;
}
@media (max-width: 768px) {
  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
    width: 81px;
  }
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails {
  height: 100%;
  width: 100%;
  left: 0;
  padding: 0;
  position: absolute;
  top: 0;
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails .image-gallery-thumbnail, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails .image-gallery-thumbnail {
  display: block;
  margin-right: 0;
  padding: 0;
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails .image-gallery-thumbnail + .image-gallery-thumbnail, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails .image-gallery-thumbnail + .image-gallery-thumbnail {
  margin-left: 0;
  margin-top: 2px;
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
  margin: 0 5px;
}
@media (max-width: 768px) {
  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
    margin: 0 3px;
  }
}

.image-gallery-thumbnails {
  overflow: hidden;
  padding: 5px 0;
}
@media (max-width: 768px) {
  .image-gallery-thumbnails {
    padding: 3px 0;
  }
}
.image-gallery-thumbnails .image-gallery-thumbnails-container {
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
}

.image-gallery-thumbnail {
  display: inline-block;
  border: 4px solid transparent;
  transition: border 0.3s ease-out;
  width: 100px;
  background: transparent;
  padding: 0;
}
@media (max-width: 768px) {
  .image-gallery-thumbnail {
    border: 3px solid transparent;
    width: 81px;
  }
}
.image-gallery-thumbnail + .image-gallery-thumbnail {
  margin-left: 2px;
}
.image-gallery-thumbnail .image-gallery-thumbnail-inner {
  display: block;
  position: relative;
}
.image-gallery-thumbnail .image-gallery-thumbnail-image {
  vertical-align: middle;
  width: 100%;
  line-height: 0;
}
.image-gallery-thumbnail.active, .image-gallery-thumbnail:focus {
  outline: none;
  border: 4px solid #337ab7;
}
@media (max-width: 768px) {
  .image-gallery-thumbnail.active, .image-gallery-thumbnail:focus {
    border: 3px solid #337ab7;
  }
}
@media (hover: hover) and (pointer: fine) {
  .image-gallery-thumbnail:hover {
    outline: none;
    border: 4px solid #337ab7;
  }
}
@media (hover: hover) and (pointer: fine) and (max-width: 768px) {
  .image-gallery-thumbnail:hover {
    border: 3px solid #337ab7;
  }
}

.image-gallery-thumbnail-label {
  box-sizing: border-box;
  color: white;
  font-size: 1em;
  left: 0;
  line-height: 1em;
  padding: 5%;
  position: absolute;
  top: 50%;
  text-shadow: 0 2px 2px #1a1a1a;
  transform: translateY(-50%);
  white-space: normal;
  width: 100%;
}
@media (max-width: 768px) {
  .image-gallery-thumbnail-label {
    font-size: 0.8em;
    line-height: 0.8em;
  }
}

.image-gallery-index {
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  line-height: 1;
  padding: 10px 20px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 4;
}
@media (max-width: 768px) {
  .image-gallery-index {
    font-size: 0.8em;
    padding: 5px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/react-image-gallery/styles/scss/image-gallery.scss"],"names":[],"mappings":"AAgBA;EACE,WAfS;EAgBT,6BAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,sCAAA;AAfF;AAiBE;EACE;IACE,cA1BI;EAWR;EAgBI;IACE,qBAAA;EAdN;AACF;AAkBE;EAEE,0BAAA;AAjBJ;;AAuBI;EACE,aAAA;AApBN;;AAyBA;;EAEE,SAAA;EACA,aAAA;AAtBF;AAwBE;;EACE,YAAA;EACA,WAAA;AArBJ;AAwBE;EAVF;;IAWI,aAAA;EApBF;EAsBE;;IACE,YAAA;IACA,WAAA;EAnBJ;AACF;AAsBE;EAnBF;;IAoBI,aAAA;EAlBF;EAoBE;;IACE,YAAA;IACA,WAAA;EAjBJ;AACF;;AAqBA;EACE,QAAA;AAlBF;;AAqBA;EACE,OAAA;AAlBF;;AAqBA;;EAEE,kBAAA;EACA,QAAA;EACA,2BAAA;AAlBF;AAoBE;;EACE,aAAA;EACA,WAAA;AAjBJ;AAoBE;EACE;;IACE,YAAA;IACA,WAAA;EAjBJ;AACF;AAoBE;EACE;;IACE,YAAA;IACA,WAAA;EAjBJ;AACF;AAoBE;;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;AAjBJ;;AAqBA;EACE,OAAA;AAlBF;;AAqBA;EACE,QAAA;AAlBF;;AAsBA;EAtHI,yBAAA;EAAA,oBAAA;EAAA,iBAAA;EAwHF,6CA7He;EA8Hf,kBAAA;AAfF;AAiBE;EACE,gBApIO;EAqIP,SAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;AAfJ;AAiBI;EACE,QAAA;EACA,2BAAA;AAfN;;AAoBA;EACE,kBAAA;EACA,cAAA;EACA,MAAA;AAjBF;AAmBE;EACE,gBA3JO;AA0IX;AAoBE;EACE,8BAAA;AAlBJ;AAuBI;EACE,iBAAA;AArBN;;AA0BA;EACE,kBAAA;AAvBF;AAyBE;EAEE,qBAAA;EACA,yBAAA;AAxBJ;AA0BI;EALF;IAMI,wBAAA;EAvBJ;AACF;AAyBE;EACE,cAAA;AAvBJ;;AA2BA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAxBF;;AA2BA;EACE,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AAxBF;AA0BE;EACE,kBAAA;AAxBJ;AA2BE;EACE,WAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,8BAjNkB;EAkNlB,YAAA;EACA,WAtNO;EAuNP,OAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AA1BJ;AA4BI;EAVF;IAWI,YAAA;IACA,gBAAA;IACA,iBAAA;EAzBJ;AACF;;AA8BA;EACE,YAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AA3BF;AA6BE;EACE,SAAA;EACA,UAAA;EACA,kBAAA;AA3BJ;AA8BE;EACE,gBAAA;EACA,6BAAA;EACA,sBAAA;EACA,kBAAA;EACA,6BArPQ;EAsPR,eAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;AA5BJ;AA8BI;EAbF;IAcI,aAAA;IACA,YAAA;EA3BJ;AACF;AA6BI;EAlBF;IAmBI,cAAA;EA1BJ;AACF;AA4BI;EACE,qBAAA;EACA,mBA3QI;EA4QJ,yBAAA;AA1BN;AA6BI;EACE,qBAAA;EACA,sBAAA;EACA,gBApRK;AAyPX;AA8BI;EACE;IACE,mBAvRE;IAwRF,yBAAA;EA5BN;EA+BI;IACE,mBA5RE;EA+PR;AACF;;AAkCA;EACE,kBAAA;AA/BF;AAiCE;EACE,mBAAA;AA/BJ;AAkCE;EACE,mBAAA;AAhCJ;AAmCE;EACE,cAAA;AAjCJ;AAmCE;EAEE,qBAAA;EACA,mBAAA;EACA,YAAA;AAlCJ;AAoCI;EANF;IAOI,WAAA;EAjCJ;AACF;AAmCI;EACE,YAAA;EACA,WAAA;EACA,OAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;AAjCN;AAmCM;EACE,cAAA;EACA,eAAA;EACA,UAAA;AAjCR;AAmCQ;EACE,cAAA;EACA,eAAA;AAjCV;AAyCE;EAEE,aAAA;AAxCJ;AA0CI;EAJF;IAKI,aAAA;EAvCJ;AACF;;AA2CA;EACE,gBAAA;EACA,cAAA;AAxCF;AA0CE;EAJF;IAKI,cAAA;EAvCF;AACF;AAyCE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;AAvCJ;;AA4CA;EACE,qBAAA;EACA,6BAAA;EACA,gCAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;AAzCF;AA2CE;EARF;IASI,6BAAA;IACA,WAAA;EAxCF;AACF;AA0CE;EACE,gBAAA;AAxCJ;AA2CE;EACE,cAAA;EACA,kBAAA;AAzCJ;AA4CE;EACE,sBAAA;EACA,WAAA;EACA,cAAA;AA1CJ;AA6CE;EAEE,aAAA;EACA,yBAAA;AA5CJ;AA8CI;EALF;IAMI,yBAAA;EA3CJ;AACF;AA8CE;EACE;IACE,aAAA;IACA,yBAAA;EA5CJ;AACF;AA6CM;EAJF;IAKI,yBAAA;EA1CN;AACF;;AAgDA;EACE,sBAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,8BApaU;EAqaV,2BAAA;EACA,mBAAA;EACA,WAAA;AA7CF;AA+CE;EAdF;IAeI,gBAAA;IACA,kBAAA;EA5CF;AACF;;AA+CA;EACE,8BAlboB;EAmbpB,WAtbS;EAubT,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AA5CF;AA8CE;EAVF;IAWI,gBAAA;IACA,iBAAA;EA3CF;AACF","sourcesContent":["$ig-small-screen: 768px !default;\n$ig-xsmall-screen: 480px !default;\n$ig-white: #fff !default;\n$ig-black: #000 !default;\n$ig-blue: #337ab7 !default;\n$ig-background-black: rgba(0, 0, 0, .4) !default;\n$ig-transparent: rgba(0, 0, 0, 0) !default;\n$ig-shadow: 0 2px 2px lighten($ig-black, 10%);\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$vendor}#{$name}: #{$value};\n  }\n}\n\n// SVG ICON STYLES\n.image-gallery-icon {\n  color: $ig-white;\n  transition: all .3s ease-out;\n  appearance: none;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  outline: none;\n  position: absolute;\n  z-index: 4;\n  filter: drop-shadow($ig-shadow);\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      color: $ig-blue;\n      .image-gallery-svg {\n        transform: scale(1.1);\n      }\n    }\n  }\n\n  &:focus {\n    // a11y support\n    outline: 2px solid $ig-blue;\n  }\n}\n\n.image-gallery-using-mouse {\n  .image-gallery-icon {\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\n.image-gallery-fullscreen-button,\n.image-gallery-play-button {\n  bottom: 0;\n  padding: 20px;\n\n  .image-gallery-svg {\n    height: 28px;\n    width: 28px;\n  }\n\n  @media (max-width: $ig-small-screen) {\n    padding: 15px;\n\n    .image-gallery-svg {\n      height: 24px;\n      width: 24px;\n    }\n  }\n\n  @media (max-width: $ig-xsmall-screen) {\n    padding: 10px;\n\n    .image-gallery-svg {\n      height: 16px;\n      width: 16px;\n    }\n  }\n}\n\n.image-gallery-fullscreen-button {\n  right: 0;\n}\n\n.image-gallery-play-button {\n  left: 0;\n}\n\n.image-gallery-left-nav,\n.image-gallery-right-nav {\n  padding: 50px 10px;\n  top: 50%;\n  transform: translateY(-50%);\n\n  .image-gallery-svg {\n    height: 120px;\n    width: 60px;\n  }\n\n  @media (max-width: $ig-small-screen) {\n    .image-gallery-svg {\n      height: 72px;\n      width: 36px;\n    }\n  }\n\n  @media (max-width: $ig-xsmall-screen) {\n    .image-gallery-svg {\n      height: 48px;\n      width: 24px;\n    }\n  }\n\n  &[disabled] {\n    cursor: disabled;\n    opacity: .6;\n    pointer-events: none;\n  }\n}\n\n.image-gallery-left-nav {\n  left: 0;\n}\n\n.image-gallery-right-nav {\n  right: 0;\n}\n// End of Icon styles\n\n.image-gallery {\n  @include vendor-prefix('user-select', none);\n  -webkit-tap-highlight-color: $ig-transparent;\n  position: relative;\n\n  &.fullscreen-modal {\n    background: $ig-black;\n    bottom: 0;\n    height: 100%;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    width: 100%;\n    z-index: 5;\n\n    .image-gallery-content {\n      top: 50%;\n      transform: translateY(-50%);\n    }\n  }\n}\n\n.image-gallery-content {\n  position: relative;\n  line-height: 0;\n  top: 0;\n\n  &.fullscreen {\n    background: $ig-black;\n  }\n\n  .image-gallery-slide .image-gallery-image {\n    max-height: calc(100vh - 80px); // 80 px for the thumbnail space\n  }\n\n  &.image-gallery-thumbnails-left,\n  &.image-gallery-thumbnails-right {\n    .image-gallery-slide .image-gallery-image {\n      max-height: 100vh;\n    }\n  }\n}\n\n.image-gallery-slide-wrapper {\n  position: relative;\n\n  &.image-gallery-thumbnails-left,\n  &.image-gallery-thumbnails-right {\n    display: inline-block;\n    width: calc(100% - 110px); // 100px + 10px for margin\n\n    @media (max-width: $ig-small-screen) {\n      width: calc(100% - 87px); // 81px + 6px for margin\n    }\n  }\n  &.image-gallery-rtl {\n    direction: rtl;\n  }\n}\n\n.image-gallery-slides {\n  line-height: 0;\n  overflow: hidden;\n  position: relative;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.image-gallery-slide {\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n\n  &.image-gallery-center {\n    position: relative;\n  }\n\n  .image-gallery-image {\n    width: 100%;\n    object-fit: contain;\n  }\n\n  .image-gallery-description {\n    background: $ig-background-black;\n    bottom: 70px;\n    color: $ig-white;\n    left: 0;\n    line-height: 1;\n    padding: 10px 20px;\n    position: absolute;\n    white-space: normal;\n\n    @media (max-width: $ig-small-screen) {\n      bottom: 45px;\n      font-size: .8em;\n      padding: 8px 15px;\n    }\n\n  }\n}\n\n.image-gallery-bullets {\n  bottom: 20px;\n  left: 0;\n  margin: 0 auto;\n  position: absolute;\n  right: 0;\n  width: 80%;\n  z-index: 4;\n\n  .image-gallery-bullets-container {\n    margin: 0;\n    padding: 0;\n    text-align: center;\n  }\n\n  .image-gallery-bullet {\n    appearance: none;\n    background-color: transparent;\n    border: 1px solid $ig-white;\n    border-radius: 50%;\n    box-shadow: $ig-shadow;\n    cursor: pointer;\n    display: inline-block;\n    margin: 0 5px;\n    outline: none;\n    padding: 5px;\n    transition: all .2s ease-out;\n\n    @media (max-width: $ig-small-screen) {\n      margin: 0 3px;\n      padding: 3px;\n    }\n\n    @media (max-width: $ig-xsmall-screen) {\n      padding: 2.7px;\n    }\n\n    &:focus {\n      transform: scale(1.2);\n      background: $ig-blue;\n      border: 1px solid $ig-blue;\n    }\n\n    &.active {\n      transform: scale(1.2);\n      border: 1px solid $ig-white;\n      background: $ig-white;\n    }\n\n    @media (hover: hover) and (pointer: fine) {\n      &:hover {\n        background: $ig-blue;\n        border: 1px solid $ig-blue;\n      }\n\n      &.active:hover {\n        background: $ig-blue;\n      }\n    }\n  }\n}\n\n.image-gallery-thumbnails-wrapper {\n  position: relative;\n\n  &.thumbnails-swipe-horizontal {\n    touch-action: pan-y;\n  }\n\n  &.thumbnails-swipe-vertical {\n    touch-action: pan-x;\n  }\n\n  &.thumbnails-wrapper-rtl {\n    direction: rtl;\n  }\n  &.image-gallery-thumbnails-left,\n  &.image-gallery-thumbnails-right {\n    display: inline-block;\n    vertical-align: top;\n    width: 100px;\n\n    @media (max-width: $ig-small-screen) {\n      width: 81px; // 75px + 6px for border\n    }\n\n    .image-gallery-thumbnails {\n      height: 100%;\n      width: 100%;\n      left: 0;\n      padding: 0;\n      position: absolute;\n      top: 0;\n\n      .image-gallery-thumbnail {\n        display: block;\n        margin-right: 0;\n        padding: 0;\n\n        + .image-gallery-thumbnail {\n          margin-left: 0;\n          margin-top: 2px;\n        }\n\n      }\n\n    }\n  }\n\n  &.image-gallery-thumbnails-left,\n  &.image-gallery-thumbnails-right {\n    margin: 0 5px;\n\n    @media (max-width: $ig-small-screen) {\n      margin: 0 3px;\n    }\n  }\n}\n\n.image-gallery-thumbnails {\n  overflow: hidden;\n  padding: 5px 0;\n\n  @media (max-width: $ig-small-screen) {\n    padding: 3px 0;\n  }\n\n  .image-gallery-thumbnails-container {\n    cursor: pointer;\n    text-align: center;\n    white-space: nowrap;\n  }\n\n}\n\n.image-gallery-thumbnail {\n  display: inline-block;\n  border: 4px solid transparent;\n  transition: border .3s ease-out;\n  width: 100px;\n  background: transparent;\n  padding: 0;\n\n  @media (max-width: $ig-small-screen) {\n    border: 3px solid transparent;\n    width: 81px;\n  }\n\n  + .image-gallery-thumbnail {\n    margin-left: 2px;\n  }\n\n  .image-gallery-thumbnail-inner {\n    display: block;\n    position: relative;\n  }\n\n  .image-gallery-thumbnail-image {\n    vertical-align: middle;\n    width: 100%;\n    line-height: 0;\n  }\n\n  &.active,\n  &:focus {\n    outline: none;\n    border: 4px solid $ig-blue;\n\n    @media (max-width: $ig-small-screen) {\n      border: 3px solid $ig-blue;\n    }\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      outline: none;\n      border: 4px solid $ig-blue;\n\n      @media (max-width: $ig-small-screen) {\n        border: 3px solid $ig-blue;\n      }\n    }\n  }\n\n}\n\n.image-gallery-thumbnail-label {\n  box-sizing: border-box;\n  color: white;\n  font-size: 1em;\n  left: 0;\n  line-height: 1em;\n  padding: 5%;\n  position: absolute;\n  top: 50%;\n  text-shadow: $ig-shadow;\n  transform: translateY(-50%);\n  white-space: normal;\n  width: 100%;\n\n  @media(max-width: $ig-small-screen) {\n    font-size: .8em;\n    line-height: .8em;\n  }\n}\n\n.image-gallery-index {\n  background: $ig-background-black;\n  color: $ig-white;\n  line-height: 1;\n  padding: 10px 20px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 4;\n\n  @media(max-width: $ig-small-screen) {\n    font-size: .8em;\n    padding: 5px 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
